import fields from '../graphql/schema/validation.json';
import { Maybe } from '../graphql/schema/p4types';

export default (entity: string, field: string): Maybe<string> => {
  const fieldElement: any = fields[entity][field];

  if (!fieldElement) {
    return null;
  }

  let type: string = fieldElement.type;

  if (type === 'List' || type === 'Set') {
    type = fieldElement.typeParameters[0];
  }

  return type;
};
